import { baseApi } from 'core/api';

const state = () => ({});

const getters = {};

const actions = {
    updateSegmentEvents({ eventType = 'track', payload = {} }) {
        return baseApi.post(
            'segment/v1/events',
            {
                eventType: eventType,
                payload: payload,
            },
            {
                auth: false,
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
};
